import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/bulkDownload';

const initialState = fromJS({
  tmp: {},
  downloads: {}
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.createTmpDownload: {
      const { totalFiles } = action.payload;

      return state.setIn(['tmp'], fromJS({ totalFiles }));
    }
    case actions.deleteTmpDownload: {
      return state.setIn(['tmp', fromJS({})]);
    }
    case actions.startDownload: {
      const { downloadId } = action.payload;
      const totalFiles = state.getIn(['tmp', 'totalFiles'], 1);

      state.setIn(
        ['downloads', String(downloadId)],
        fromJS({
          status: 'PROGRESS',
          totalFiles,
          urlFile: ''
        })
      );

      return state.setIn(['tmp', fromJS({})]);
    }
    case actions.completedDownload: {
      const { downloadId, urlFile } = action.payload;

      const totalFiles = state.getIn(['tmp', 'totalFiles'], 1);

      state.setIn(['tmp', fromJS({})]);

      return state.setIn(
        ['downloads', String(downloadId)],
        fromJS({
          status: 'COMPLETED',
          urlFile,
          totalFiles
        })
      );
    }
    case actions.cancelDownload:
    case actions.removeDownload: {
      const { downloadId } = action.payload;

      return state.removeIn(['downloads', downloadId]);
    }
    case actions.clear: {
      return initialState;
    }
    default:
      return state;
  }
};
